

export default {
    components: {
    },
    props: {
        unit: {
            type: Object,
            required: true,
        }
    },
    created() {
        let t = this;

        if (t.unit.managers) {
            t.unit.managers.forEach(item => {
                if (item.grant) {
                    let g = item.grant;

                    for (let key in g) {
                        if (key != 'id' && (g[key] == 1 || g[key] == 0))
                            g[key] = g[key] == 1;
                    }

                    for (let key in g) {
                        if (!g[key])
                            t.all[key] = false;
                    }

                }
            });
        }

    },
    activated() {
        let t = this;
    },
    methods: {

        updateAll() {

            let t = this;

            let a = {
                clock_in: true,
                review: true,

                field_work: true,
                work_online: true,

                leave_review: true,
                att_review: true,
                att_schedule_review: true,
                second_review: true,

                daily_report: true,
                clean_mgr: true,
            };

            t.unit.managers.forEach(item => {
                if (item.grant) {
                    let g = item.grant;
                    for (let key in g) {
                        if (!g[key])
                            a[key] = false;
                    }
                }
            });

            mirror(a, t.all);

        },

        updateToggles(p) {

            let t = this;

            t.unit.managers.forEach(item => {
                if (item.grant) {
                    let g = item.grant;

                    if (p == 1) {
                        g.field_work = g.clock_in;
                        g.work_online = g.clock_in;
                    }

                    else if (p == 2) {
                        g.leave_review = g.review;
                        g.att_review = g.review;
                        g.att_schedule_review = g.review;
                        g.second_review = g.review;

                    }

                }
            });

            t.updateAll();
        },

        updateToggles2() {

            let t = this;

            t.unit.managers.forEach(item => {
                if (item.grant) {
                    let g = item.grant;

                    g.daily_report = t.all.daily_report;
                    g.clean_mgr = t.all.clean_mgr;

                }
            });
        },

        updateAllToggles(type, field) {

            let t = this;

            if (type == 1) {
                t.all.field_work = t.all.clock_in;
                t.all.work_online = t.all.clock_in;

                t.unit.managers.forEach(item => {
                    if (item.grant) {
                        let g = item.grant;
                        g.clock_in = t.all.clock_in;
                        g.field_work = t.all.field_work;
                        g.work_online = t.all.work_online;
                    }
                });
            }
            else {
                t.unit.managers.forEach(item => {
                    if (item.grant) {
                        let g = item.grant;
                        g[field] = t.all[field];
                    }
                });
            }

        },

        updateAllToggles2(type, field) {

            let t = this;

            if (type == 1) {

                t.all.leave_review = t.all.review;
                t.all.att_review = t.all.review;
                t.all.att_schedule_review = t.all.review;
                t.all.second_review = t.all.review;

                t.unit.managers.forEach(item => {
                    if (item.grant) {
                        let g = item.grant;

                        g.review = t.all.review;
                        g.leave_review = t.all.leave_review;
                        g.att_review = t.all.att_review;
                        g.att_schedule_review = t.all.att_schedule_review;
                        g.second_review = t.all.second_review;
                    }
                });
            }
            else {
                t.unit.managers.forEach(item => {
                    if (item.grant) {
                        let g = item.grant;
                        g[field] = t.all[field];
                    }
                });
            }

        },

        saveAccessGrant() {
            let t = this;

            let data = [];

            if (t.busying)
                return;

            t.busying = true;

            t.unit.managers.forEach(item => {
                if (item.grant) {
                    let g = item.grant;
                    data.push(g);
                }
            });

            axios.post('grant/batchSave', { items: data }).then(res => {
                t.busying = false;

                if (res.data.status == 1) {
                    A.toast('Saved.');
                    t.$emit('close');
                }
            });

        }

    },
    data() {
        return {
            more: {
                clock_in: true,
                review: true,
            },
            all: {
                clock_in: true,
                review: true,

                field_work: true,
                work_online: true,

                leave_review: true,
                att_review: true,
                att_schedule_review: true,
                second_review: true,

                daily_report: true,
                clean_mgr: true,
            }
        };
    },
    computed: {
    }
};
